import Native from "./Native";
import Sound = createjs.Sound;
import WebAudioPlugin = createjs.WebAudioPlugin;

export default class SoundManager {

    public static muted = false;
    public static lastSoundInstance: createjs.AbstractSoundInstance = null;

    public static playSound(sound) {

        if (!Native.isSoundEnabled() || SoundManager.muted)
            return null;

        SoundManager.stop();

        console.log('Playing: ' + sound);
        try {
            SoundManager.tryResumeWebAudioContext();

            SoundManager.lastSoundInstance = Sound.play(sound, {loop: 0, volume: 1})
            return SoundManager.lastSoundInstance;

        } catch (e) {
            // we're probably trying to play sound outside of a touch event (via callbacks)
            console.log(e);
            return null;
        }
    }

    /**
     * Stop the currently playing sound, if playing.
     */
    public static stop() {
        if (!SoundManager.lastSoundInstance)
            return;

        try {
            SoundManager.lastSoundInstance.stop();
        } catch (e) {
            console.log("Could not stop sound", e);
        }
        SoundManager.lastSoundInstance = null;
    }

    public static playSounds(sounds: string[], cb: () => void = null) {

        console.log('playSounds:', sounds);
        if (sounds.length == 0) {
            if (cb) cb();
            return;
        }

        let first = sounds[0];
        let snd = this.playSound(first);
        let nextCb = () => this.playSounds(sounds.slice(1), cb);

        if (snd) {
            snd.on('complete', nextCb);
            snd.on('failed', () => {
                console.log('playback failed for ', snd);
                nextCb();
            });
        } else {
            // sound muted?
            nextCb();
        }
    }

    // Under iOS, the web audio context is sometimes suspended when the webview
    // is backgrounded. Try to resume it.
    private static tryResumeWebAudioContext() {
        try {
            // if there is no audio context, nothing to resume
            // (or not using WebAudioPlugin?)
            if (!WebAudioPlugin.context)
                return;

            // use 'any', as the typescript definition of context-state does not include all iOS states (like 'interrupted')
            var contextState: any = WebAudioPlugin.context.state;

            if (contextState == 'suspended' || contextState == 'interrupted') {
                console.log('Audio context state:' + WebAudioPlugin.context.state);
                WebAudioPlugin.context.resume();
                console.log('Resumed suspended audio context');
            }

        } catch (e) {
            // ignore.
        }
    }

}



// WEBPACK FOOTER //
// ../lib/src/SoundManager.ts